module.exports = __webpack_public_path__ + "img/FinalLogo.15e0675d.png";